import { useModel } from "@bcm-dev/bcms-vite";
import AddUnlinkedTransferAccountWorkflow from 'components/workflows/AddUnlinkedTransferAccountWorkflow';
import CustomModal from '../..';
import "./styles.css";
import "./mobile.css";


export default function AddUnlinkedTransferAccountModal(props) {
  const { branding } = useModel();
  const { options } = branding;
  let step = options.transfer_account_type_modal_abi22 === "true" ? 0 : 1;
  step = props.data ? props.data.step : step;
  const form = props.data ? props.data.form : undefined;
  
  return (
      <CustomModal id="AddUnlinkedTransferAccountModal" title="Add Transfer Account" className="add-unlinked-transfer-account-modal">
          <AddUnlinkedTransferAccountWorkflow { ...props.data } step={ step } form={ form } />
      </CustomModal>
  );
}
